import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import CheckboxDemo from './CheckboxDemo'
import CheckboxEditorActions from './CheckboxEditorActions'
import CheckboxElement from './CheckboxElement'
import CheckboxFormBrand from './CheckboxFormBrand'
import { STYLE_FORM_SCHEMA } from './CheckboxFormStyle'
import CheckboxFormValue from './CheckboxFormValue'
import checkboxIcon from './assets/checkbox.svg'

export default genElementConfig(CONFIG_ELEMENTS.checkbox, {
  label: t('elements.checkbox.label'),
  icon: checkboxIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: CheckboxElement,
  Demo: [CheckboxDemo],
  FormValue: CheckboxFormValue,
  FormBrand: CheckboxFormBrand,
  EditorActions: CheckboxEditorActions,
})
